/**
 * Content card component
 * 
 */

import React, { PureComponent } from 'react';
import { RichText } from 'prismic-reactjs';

// Components

import Image from '../image/image';

export default class ContentCard extends PureComponent {

	render() {
		
		const { data } = this.props;

		const alignment = ' card-' + data.alignment.toLowerCase();
		const classes = 'card card-section' + alignment + ' mt-9 ';

		return (
			
			<div className={classes}>
			<div className="card-details">

				{ RichText.render(data.text) }

			</div>
			<figure className="card-image"><Image data={data.image}/></figure>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/contents/content-card.js